import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71780570"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Actualizar Cargos", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Cargo", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Descripción", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Tipo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "M" }, "Manejo", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Almacenaje", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "R" }, "Refrigeración", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Status", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))

import { Ref, ref } from 'vue'
import axios from 'axios'
import { UrlGlobal } from '@/store/dominioGlobal';
import { useAlert } from '@/store/useAlert';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpCargCaman',
  props: {
    btnUp: Boolean,
    cargo: String,
    nombre: String,
    tipo: String,
    status: String

},
  emits: ['updateProps'],
  setup(__props, { emit: __emit }) {

const { success } = useAlert()
const dUrl = UrlGlobal()

//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("updateProps", !props.btnUp)
}
//------------------------------------------------------------------------------

//variables reactivas para el formulario----------------------------------------
let cargo = ref(props.cargo)
let nombre = ref(props.nombre)
let tipo = ref(props.tipo)
let status = ref(props.status)
//------------------------------------------------------------------------------
const handleSubmit = async () => {
    try {
        const response = await axios.post(dUrl.urlGlobal +'/api2/update/', {
            table: 'cargcaman', 
            filters: { cargo: cargo.value }, // Filtro para identificar el registro a actualizar
            data: { nombre: nombre.value, tipo: tipo.value, status: status.value } // Datos a actualizar
        })
        //console.log(response.data)
        success('Información actualizada...', '')
        emits("updateProps", !props.btnUp)
    } catch (error) {
        console.error("Error actualizando datos:", error)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom01",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cargo) ? (cargo).value = $event : cargo = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(cargo)]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(nombre) ? (nombre).value = $event : nombre = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _unref(nombre)]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            id: "validationCustom04",
            required: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(tipo) ? (tipo).value = $event : tipo = $event))
          }, _hoisted_17, 512), [
            [_vModelSelect, _unref(tipo)]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            id: "validationCustom04",
            required: "",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
          }, _hoisted_22, 512), [
            [_vModelSelect, _unref(status)]
          ]),
          _hoisted_23
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})